import { render } from "./ModificaDati.vue?vue&type=template&id=25a9c4b9&scoped=true"
import script from "./ModificaDati.vue?vue&type=script&lang=js"
export * from "./ModificaDati.vue?vue&type=script&lang=js"

import "./ModificaDati.vue?vue&type=style&index=0&id=25a9c4b9&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a9c4b9"]])

export default __exports__